import { PolicyPodetailReq, PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { PaymentCreditAuthReq } from 'app/bff/models/payment/paymentCreditAuth';
import { ProcessStepCodesEnum } from 'app/features/Service/QueryPolicy/Pay/types';

// State type
export interface PayState {
  static: StaticState;
  process: ProcessState;
  policyStatus?: PolicyStatusState;
}

interface StaticState {
  detail?: PolicyPodetailResp['policyTravel'];
  paymentWSUUID?: string;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  confirmInfo: {
    otpAuth: {
      otp?: AaOtpSendcodeResp;
    };
  };
}

interface PolicyStatusState {
  isUnpaid?: boolean;
  paymentDeadline?: string;
}
// ::: End

// Actions type constant
export const SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL = 'SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL';
export const SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL_DONE = 'SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL_DONE';
export const SERVICE_QUERY_POLICY_PAY__SET_ACCESSIBLE_STEP = 'SERVICE_QUERY_POLICY_PAY__SET_ACCESSIBLE_STEP';
export const SERVICE_QUERY_POLICY_PAY__SEND_OTP = 'SERVICE_QUERY_POLICY_PAY__SEND_OTP';
export const SERVICE_QUERY_POLICY_PAY__SEND_OTP_DONE = 'SERVICE_QUERY_POLICY_PAY__SEND_OTP_DONE';
export const SERVICE_QUERY_POLICY_PAY__RESEND_OTP = 'SERVICE_QUERY_POLICY_PAY__RESEND_OTP';
export const SERVICE_QUERY_POLICY_PAY__RESEND_OTP_DONE = 'SERVICE_QUERY_POLICY_PAY__RESEND_OTP_DONE';
export const SERVICE_QUERY_POLICY_PAY__AUTH_OTP = 'SERVICE_QUERY_POLICY_PAY__AUTH_OTP';
export const SERVICE_QUERY_POLICY_PAY__SET_POLICY_STATUS = 'SERVICE_QUERY_POLICY_PAY__SET_POLICY_STATUS';
export const SERVICE_QUERY_POLICY_PAY__EXECUTE_CREDIT_CARD_PAYMENT = 'SERVICE_QUERY_POLICY_PAY__EXECUTE_CREDIT_CARD_PAYMENT';
export const SERVICE_QUERY_POLICY_PAY__UPDATE_CACHE = 'SERVICE_QUERY_POLICY_PAY__UPDATE_CACHE';
export const SERVICE_QUERY_POLICY_PAY__RESET_CACHE = 'SERVICE_QUERY_POLICY_PAY__RESET_CACHE';
// ::: End

// Action creators type
export interface FetchPolicyDetailAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL;
  payload: {
    args: PolicyPodetailReq;
  };
}

export interface FetchPolicyDetailDoneAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__FETCH_POLICY_DETAIL_DONE;
  payload: {
    response: PolicyPodetailResp['policyTravel'];
  };
}

export interface SetAccessibleStepAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface SendOTPAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__SEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface SendOTPDoneAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__SEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface ResendOTPAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__RESEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface ResendOTPDoneAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__RESEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthOTPAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__AUTH_OTP;
  payload: {
    args: AaOtpVerifyReq;
  };
}

export interface SetPolicyStatusAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__SET_POLICY_STATUS;
  payload: {
    status: PayState['policyStatus'];
  };
}

export interface ExecuteCreditCardPaymentAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__EXECUTE_CREDIT_CARD_PAYMENT;
  payload: {
    args: PaymentCreditAuthReq;
  };
}

export interface UpdateCacheAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__UPDATE_CACHE;
  payload: {
    cache: PayState;
  };
}

export interface ResetCacheAction {
  type: typeof SERVICE_QUERY_POLICY_PAY__RESET_CACHE;
}

export type PayActions =
    FetchPolicyDetailAction
  | FetchPolicyDetailDoneAction
  | SetAccessibleStepAction
  | SendOTPAction
  | SendOTPDoneAction
  | ResendOTPAction
  | ResendOTPDoneAction
  | AuthOTPAction
  | SetPolicyStatusAction
  | ExecuteCreditCardPaymentAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
